var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPenToSquare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pen-to-square",
    d: "M17.892,5.481l.476.476a1.261,1.261,0,0,1,0,1.783L17.318,8.791,15.059,6.532l1.051-1.051A1.261,1.261,0,0,1,17.892,5.481ZM7.439,14.152l6.73-6.73,2.259,2.259L9.7,16.411a1.29,1.29,0,0,1-.606.338l-2.582.594L7.1,14.758a1.226,1.226,0,0,1,.338-.606ZM15.22,4.588,6.549,13.263a2.519,2.519,0,0,0-.673,1.216l-.823,3.566a.631.631,0,0,0,.756.756l3.566-.823a2.519,2.519,0,0,0,1.216-.673L19.262,8.63a2.518,2.518,0,0,0,0-3.562l-.476-.48a2.518,2.518,0,0,0-3.562,0ZM3.149,6.217A3.148,3.148,0,0,0,0,9.366V20.7A3.148,3.148,0,0,0,3.149,23.85H14.484A3.148,3.148,0,0,0,17.633,20.7V15.663a.63.63,0,1,0-1.259,0V20.7a1.89,1.89,0,0,1-1.889,1.889H3.149A1.89,1.89,0,0,1,1.259,20.7V9.366A1.89,1.89,0,0,1,3.149,7.477H8.187a.63.63,0,0,0,0-1.259Z",
    transform: "translate(0 -3.85)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPenToSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pen-to-square.f2aea2dad9f60ff25bb339b97ef458d6.svg";